<template>
  <el-dialog
    v-dialogDrag
    :append-to-body="true"
    :visible.sync="visible"
    :title="title"
    :close-on-click-modal="false"
    @closed="closeDialog"
    class="small-dialog"
  >
    <el-form
      ref="operateForm"
      :model="operateForm"
      :rules="operateRules"
      label-width="150px"
      v-if="operateForm"
    >
      <template v-for="(item, index) in formItemList">
        <el-form-item v-if="!item.hidden" :key="index" :label="item.label" :prop="item.prop">
          <el-input
            v-model="operateForm[item.prop]"
            size="small"
            clearable
            type="textarea"
            resize="none"
            rows="3"
            v-if="item.type === 'textarea'"
          ></el-input>
          <el-input
            v-model="operateForm[item.prop]"
            size="small"
            clearable
            :show-password="item.type === 'password'"
            v-else
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save"
        :loading="saveLoading"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    operateRules: {
      type: Object,
      default: () => {
        return {}
      },
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    formItemList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      operateForm: null,
    }
  },
  watch: {
    formItemList(val) {
      if (val.length) {
        const form = {}
        _.forEach(val, (item) => {
          form[item.prop] = _.isNil(item.value) ? '' : item.value
        })
        this.operateForm = form
        this.$nextTick(() => {
          this.$refs.operateForm.clearValidate()
        })
      }
    },
  },
  methods: {
    save() {
      this.$refs.operateForm.validate(async (valid) => {
        if (valid) {
          this.$emit('save', this.operateForm)
        }
      })
    },
    closeDialog() {
      this.$emit('closed')
    },
  },
}
</script>
